module.exports = __webpack_public_path__ + "static/media/1012555.21587fcc.jpg";